import React from 'react';
import Header from '../header';
import AccountInfo from './accountInfo';
import AccountsDropDown from './accountsDropdown';
import styles from './accountStyling.module.css';

function Accounts(){
    return(
        <div>
            <Header/>
            <main id={styles.accountsMain}>
            <AccountsDropDown />
            <AccountInfo />
            </main>
        </div>
    ) 
}

export default Accounts